import { Component, ViewChild } from '@angular/core';
import { ProdutividadeFilterComponent } from '../../components/filter';
import { ProdutividadeViewService } from '../../services';

@Component({
    selector: 'sgt-produtividade-view',
    templateUrl: './produtividade-view.component.html',
    styleUrls: ['./produtividade-view.component.less']
})
export class ProdutividadeViewComponent {
    /** Component do filter */
    @ViewChild('filterComponent') filterComponent: ProdutividadeFilterComponent;

    constructor(private produtividadeViewService: ProdutividadeViewService) { }

    /** Quando o filtro for inicializado */
    onFilterInitialized() {
        this.load();
    }

    /** Ao alterar algum valor do filtro */
    onFilterChange() {
        this.load();
    }

    /** Ao limpar o filtro */
    onFilterClear() {
        this.load();
    }

    private setStorage() {
        // Filter
        this.filterComponent?.setStorage();
    }

    load() {
        // Setando o storage
        this.setStorage();
        // Executando o load
        this.produtividadeViewService.execLoad(this.filterComponent?.filter);
    }
}
